import { useEffect, useState } from 'react'
import { init } from './init'

export function useInit() {
  const [didInit, setDidInit] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    ;(async () => {
      if (didInit === false) {
        await init()
        setDidInit(true)
      }
    })()
  }, [didInit])

  return didInit
}
